import { render, staticRenderFns } from "./InviterManage.vue?vue&type=template&id=3d5b4c38&scoped=true&"
import script from "./InviterManage.vue?vue&type=script&lang=js&"
export * from "./InviterManage.vue?vue&type=script&lang=js&"
import style0 from "./InviterManage.vue?vue&type=style&index=0&id=3d5b4c38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5b4c38",
  null
  
)

export default component.exports